import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {get} from "lodash"

import {FormattedMessage} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import {error as errorColor} from "@irati/ui/src/global/colors"
import {connect} from "@irati/store"

import {IconTooltip} from "../../ui/Tooltip"


const StyledTooltip = styled(IconTooltip)`
  margin-left: ${padding.tiny};
`

const ValidationTooltip = ({errors, isPhone}) => {
  return (
    <StyledTooltip color={errorColor} placement={isPhone ? "bottom" : "right"}>
      {errors.map((error) => <FormattedMessage key={error.code} id={`errors.${error.code}`} />)}
    </StyledTooltip>
  )
}

ValidationTooltip.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired
  })),
  isPhone: PropTypes.bool.isRequired
}

ValidationTooltip.defaultProps = {
  errorCodes: []
}

const mapStateToProps = ({mq}) => {
  return {
    isPhone: get(mq, "lessThan.medium", false)
  }
}


export default connect(mapStateToProps)(ValidationTooltip)
